import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Box from '@mui/material/Box';

import VariantInputGroup from 'bento-ordering/base/components/VariantInputGroup';
import {
  getVariantPrice,
  RADIO_BUTTON,
  getVariantLabel
} from 'helpers/forms/menuItem';
import StyledVariantBox from 'components/StyledVariantBox';
import { PRODUCT_VARIANT_FIELD_NAME } from 'constants/menu/menuItemDetailForm';

function ProductVariants({ formState, variants, disabled }) {
  const getParsedProductVariants = () => {
    return variants.map(
      ({ id, name, price, calories, calories_max: caloriesMax }) => ({
        label: getVariantLabel(name, calories, caloriesMax),
        value: id,
        price: getVariantPrice(price)
      })
    );
  };

  const handleChange = (input, event) => {
    input.onChange(event.target.value);
  };

  return (
    <StyledVariantBox color="borders.primary">
      <Box pt={2.5} pb={2}>
        <Field name={PRODUCT_VARIANT_FIELD_NAME}>
          {({ input }) => (
            <VariantInputGroup
              title="Size"
              fieldType={RADIO_BUTTON}
              list={getParsedProductVariants()}
              onChange={event => handleChange(input, event)}
              value={input.value || {}}
              disabled={disabled}
              required
              isSizeSection
            />
          )}
        </Field>
      </Box>
    </StyledVariantBox>
  );
}

ProductVariants.propTypes = {
  formState: PropTypes.object.isRequired,
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string,
      order: PropTypes.number,
      price: PropTypes.string,
      product: PropTypes.number,
      weight: PropTypes.string,
      calories: PropTypes.number
    })
  ).isRequired,
  disabled: PropTypes.bool.isRequired
};

export default ProductVariants;
